import { defineMessages } from "react-intl";

export const reportQueriesFilterMessages = defineMessages({
  startDate: {
    id: "report.queries.startDate",
    defaultMessage: "Start date",
  },
  endDate: {
    id: "report.queries.endDate",
    defaultMessage: "End date",
  },
});

export const reportQueriesMessages = defineMessages({
  title: {
    id: "report.queries.title",
    defaultMessage: "List of queries",
  },
  startDate: {
    id: "report.queries.startDate",
    defaultMessage: "Start date",
  },
  endDate: {
    id: "report.queries.endDate",
    defaultMessage: "End date",
  },
  period: {
    id: "report.queries.period",
    defaultMessage: "Period",
  },
  date: {
    id: "report.queries.queryDate",
    defaultMessage: "Query date",
  },
  ip: {
    id: "report.queries.ip",
    defaultMessage: "IP",
  },
  checkIn: {
    id: "report.queries.checkIn",
    defaultMessage: "Check-in",
  },
  checkOut: {
    id: "report.queries.checkOut",
    defaultMessage: "Check-out",
  },
  nights: {
    id: "report.queries.nights",
    defaultMessage: "Nights",
  },
  occupancy: {
    id: "report.queries.persons",
    defaultMessage: "Persons",
  },
  adults: {
    id: "report.queries.adults",
    defaultMessage: "Adults",
  },
  children: {
    id: "report.queries.children",
    defaultMessage: "Children",
  },
  babies: {
    id: "report.queries.babies",
    defaultMessage: "Babies",
  },
  locale: {
    id: "report.queries.language",
    defaultMessage: "Language",
  },
  hasAvailability: {
    id: "report.queries.availability",
    defaultMessage: "Availability",
  },
  isChain: {
    id: "report.queries.portal",
    defaultMessage: "Portal",
  },
  consult: {
    id: "report.queries.consult",
    defaultMessage: "Consult",
  },
  exportToExcel: {
    id: "report.queries.exportToExcel",
    defaultMessage: "Export to Excel",
  },
  resultsPerPage: {
    id: "report.queries.resultsPerPage",
    defaultMessage: "Results per page",
  },
  tableNoItems: {
    id: "report.queries.tableNoItems",
    defaultMessage: "Results are not found",
  },
  yes: {
    id: "report.queries.yes",
    defaultMessage: "Yes",
  },
  no: {
    id: "report.queries.no",
    defaultMessage: "No",
  },
});
